module.exports = __webpack_public_path__ + "assets/ruby.c59056e9.svg";